import React, { Component } from "react";
import { Grid } from "react-bootstrap";

class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <Grid fluid>
          <nav className="pull-left">
            <ul>
              <li>
                <a href="/admin/dashboard">Home</a>
              </li>
              <li>
                <a href="https://www.vlogahead.com">Company</a>
              </li>
              <li>
                <a href="/admin/logout">Logout</a>
              </li>
            </ul>
          </nav>
          <p className="copyright pull-right">
            &copy; {new Date().getFullYear()}{" "}
            <a href="http://www.vlogahead.com">
              VlogAhead
            </a>
          </p>
        </Grid>
      </footer>
    );
  }
}

export default Footer;
